import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: '',
  name: '',
  price: '',
  image: null,
  googleImage: null,
  shortDescription: '',
  description: '',
  featured: false,
  beans: false,
  fragile: false,
  version: '',
  weight: '',
  weightUnit: '',
};

export const adminAddProductSlice = createSlice({
  name: 'adminAddProduct',
  initialState,
  reducers: {
    update: (state, action) => {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    },
    updateAll: (state, action) => {
      const p = action.payload;
      return {
        ...state,
        id: p.id,
        name: p.name,
        price: p.price,
        image: p.image,
        googleImage: p.googleImage ?? null,
        shortDescription: p.shortDescription,
        description: p.description,
        featured: p.featured,
        fragile: p.fragile ?? false,
        beans: p.beans ?? false,
        version: p.version,
        weightUnit: p.weightUnit,
        weight: p.weight,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { update, updateAll, reset } = adminAddProductSlice.actions;
export default adminAddProductSlice.reducer;
export const addProduct = (state) => state.adminAdd;
